import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlJob } from "~/__generated__";

type Props = {
    job: GqlJob;
};

interface AddressImportFromCsvError {
    row: object;
    address: string;
    closestMatch?: string;
    error: string;
}

interface AddressImportFromCsvOutput {
    total?: number;
    success?: number;
    errors?: number | AddressImportFromCsvError;
}

export default function MapEditorLayerAddressImportFeedback({ job }: Props) {
    const { t } = useTranslation("mapEditor");

    const output = job.output as AddressImportFromCsvOutput | undefined;
    if (!output) return undefined;
    const numberOfErrors = (output.total ?? 0) - (output.success ?? 0);

    return (
        <Stack rowGap={1 / 2}>
            <Typography variant="caption">
                {t("mapEditorAddressImport.imported")} {output.success ?? 0}/{output.total ?? 0}{" "}
                {t("mapEditorAddressImport.addresses")}
            </Typography>
            {numberOfErrors > 0 && (
                <Typography variant="h6" color="error">
                    {t("mapEditorAddressImport.errorMessage", { numberOfErrors })}
                </Typography>
            )}
        </Stack>
    );
}
